module.exports = __webpack_public_path__ + "img/22.0b8c44b2.jpg";